import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Handshake } from "lucide-react";

export default function PartnerSettings() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/partners").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (r) => { try { await api.put("/admin/partners", { key: r.key, url: r.url, name: r.name }); toast.success("Saved"); } catch (e) { toast.error(e?.response?.data?.detail || "Invalid"); } };
  const set = (k, f, v) => setRows(rows.map((r) => (r.key === k ? { ...r, [f]: v } : r)));
  return (
    <div className="bg-card border border-border rounded-2xl p-6" data-testid="partner-settings">
      <h2 className="font-heading font-bold mb-1 flex items-center gap-2"><Handshake size={18} /> Partner / affiliate links</h2>
      <p className="text-sm text-muted-foreground mb-4">Paste your affiliate URL for each slot. Empty slots show nothing in the app. Clicks are logged.</p>
      <div className="space-y-3">
        {rows.map((r) => (
          <div key={r.key} className="grid sm:grid-cols-[1fr_2fr_auto] gap-2 items-center" data-testid={`partner-row-${r.key}`}>
            <div><p className="text-sm font-medium">{r.label}</p><p className="text-[11px] text-muted-foreground">{r.where}</p></div>
            <div className="flex gap-2"><input data-testid={`partner-name-${r.key}`} value={r.name} onChange={(e) => set(r.key, "name", e.target.value)} placeholder="Partner name" className="w-32 min-h-[40px] px-3 rounded-lg border border-input bg-card text-sm" /><input data-testid={`partner-url-${r.key}`} value={r.url} onChange={(e) => set(r.key, "url", e.target.value)} placeholder="https://…?aff=yourcode" className="flex-1 min-h-[40px] px-3 rounded-lg border border-input bg-card text-sm" /></div>
            <button data-testid={`partner-save-${r.key}`} onClick={() => save(r)} className="min-h-[40px] px-4 rounded-lg bg-navy text-white text-sm font-semibold">Save</button>
          </div>))}
      </div>
    </div>
  );
}
